export default __webpack_public_path__ + "static/media/crmFilledIcon.4d4a3ec4.svg";